export function parseCSV(text) {
    // RFC 4180-aware parser: handles quoted fields with commas and newlines
    const rows = [];
    let row = [];
    let field = '';
    let inQuotes = false;
    for (let i = 0; i < text.length; i++) {
        const ch = text[i];
        if (inQuotes) {
            if (ch === '"') {
                if (text[i + 1] === '"') { field += '"'; i++; }
                else { inQuotes = false; }
            } else {
                field += ch;
            }
        } else if (ch === '"') {
            inQuotes = true;
        } else if (ch === ',') {
            row.push(field.trim()); field = '';
        } else if (ch === '\n' || (ch === '\r' && text[i + 1] === '\n')) {
            if (ch === '\r') i++;
            row.push(field.trim()); field = '';
            if (row.some(Boolean)) rows.push(row);
            row = [];
        } else {
            field += ch;
        }
    }
    if (field || row.length) { row.push(field.trim()); if (row.some(Boolean)) rows.push(row); }
    if (rows.length < 2) return [];
    const headers = rows[0].map((h) => h.toLowerCase());
    return rows.slice(1).map((vals) => {
        const obj = {};
        headers.forEach((h, idx) => { obj[h] = vals[idx] || ''; });
        return obj;
    });
}
